/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/**
 * Action Types for ApplePay Merchant registration
 */
export var APPLE_PAY_MERCHANT_DOMAIN_FAIL = 'APPLE_PAY_MERCHANT_DOMAIN_FAIL';
export var APPLE_PAY_MERCHANT_DOMAIN_REQUEST = 'APPLE_PAY_MERCHANT_DOMAIN_REQUEST';
export var APPLE_PAY_MERCHANT_DOMAIN_RECEIVE = 'APPLE_PAY_MERCHANT_DOMAIN_RECEIVE';
/**
 * Action Types for Session Timer
 */

export var SESSION_TIMER_DECREMENT = 'SESSION_TIMER_DECREMENT';
export var SESSION_TIMER_RESET = 'SESSION_TIMER_RESET';
/**
 * Action Types for Risk Filter Settings
 */
// Get the Settings

export var RISK_FILTER_SETTINGS_FAIL = 'RISK_FILTER_SETTINGS_FAIL';
export var RISK_FILTER_SETTINGS_RECEIVE = 'RISK_FILTER_SETTINGS_RECEIVE';
export var RISK_FILTER_SETTINGS_REQUEST = 'RISK_FILTER_SETTINGS_REQUEST'; // Save the Settings

export var RISK_FILTER_SETTINGS_SAVE_FAIL = 'RISK_FILTER_SETTINGS_SAVE_FAIL';
export var RISK_FILTER_SETTINGS_SAVED = 'RISK_FILTER_SETTINGS_SAVED';
export var RISK_FILTER_SETTINGS_SAVE_REQUEST = 'RISK_FILTER_SETTINGS_SAVE_REQUEST'; // Update Form

export var RISK_FILTER_SETTINGS_FORM_UPDATE = 'RISK_FILTER_SETTINGS_FORM_UPDATE'; // Search Filter

export var RISK_FILTER_SEARCH = 'RISK_FILTER_SEARCH';
/**
 * Action Types for Custom Export Form
 */

export var CUSTOM_EXPORT_FORM = function CUSTOM_EXPORT_FORM(preference) {
  return {
    exportRequest: "".concat(preference, "/CUSTOM_EXPORT_FORM_REQUEST"),
    requestFail: "".concat(preference, "/CUSTOM_EXPORT_FORM_REQUEST_FAIL"),
    resetForm: "".concat(preference, "/CUSTOM_EXPORT_FORM_RESET"),
    responseReceive: "".concat(preference, "/CUSTOM_EXPORT_FORM_RESPONSE_RECEIVE")
  };
};
/**
 * Action Types for Modal Dialog
 */

export var MODAL_OPEN = 'MODAL_OPEN';
export var MODAL_DISMISS = 'MODAL_DISMISS';
/**
 * Action Types for Volumes for Select
 */

export var VOLUMES_FOR_SELECTION_DATA_FAIL = 'VOLUMES_FOR_SELECTION_DATA_FAIL';
export var VOLUMES_FOR_SELECTION_DATA_RECEIVE = 'VOLUMES_FOR_SELECTION_DATA_RECEIVE';
export var VOLUMES_FOR_SELECTION_DATA_REQUEST = 'VOLUMES_FOR_SELECTION_DATA_REQUEST';
/**
 * Action Types for Decrypt field
 * scope - it might be Pwd, Cvv and etc.
 */

export var DECRYPT = function DECRYPT(scope) {
  return {
    decryptFail: "".concat(scope, "/DECRYPT_FAIL"),
    fieldDecrypted: "".concat(scope, "/FIELD_DECRYPT")
  };
};
/**
 * Action Types for Blacklist and Whitelist creation.
 */

export var BLACKLIST_SAVE_FAIL = 'BLACKLIST_SAVE_FAIL';
export var BLACKLIST_SAVE_SUCCESS = 'BLACKLIST_SAVE_SUCCESS';
export var BLACKLIST_SAVE_REQUEST = 'BLACKLIST_SAVE_REQUEST';
export var BLACKLIST_FORM_UPDATE = 'BLACKLIST_FORM_UPDATE';
/**
 * Action Types for Transaction Note Review
 */

export var TRANSACTION_NOTE_REVIEW = function TRANSACTION_NOTE_REVIEW(trxNoteID) {
  return {
    fail: "".concat(trxNoteID, "/TRANSACTION_NOTE_REVIEW_FAIL"),
    receive: "".concat(trxNoteID, "/TRANSACTION_NOTE_REVIEW_RECEIVE"),
    request: "".concat(trxNoteID, "/TRANSACTION_NOTE_REVIEW_REQUEST"),
    update: "".concat(trxNoteID, "/TRANSACTION_NOTE_REVIEW_UPDATE")
  };
};
/**
 * Action Types for Mailing Service Forms
 * scope - it might be `configuration` or `template`
 */

export var EMAIL_CONFIG_FORM = function EMAIL_CONFIG_FORM(scope) {
  return {
    entityDestroy: "".concat(scope, "/ENTITY_DESTROY"),
    entityUpdate: "".concat(scope, "/ENTITY_UPDATE"),
    requestFail: "".concat(scope, "/REQUEST_FAIL"),
    requestInProgress: "".concat(scope, "/REQUEST_IN_PROGRESS"),
    reset: "".concat(scope, "/FORM_RESET"),
    responseReceive: "".concat(scope, "/RESPONSE_RECEIVE"),
    customAttributesReceive: "".concat(scope, "/CUSTOM_ATTRIBUTES_RECEIVE")
  };
};
/**
 * Action Types for Email Configuration & Email Template
 */

export var EMAIL_CONFIGURATIONS_UPDATE = 'EMAIL_CONFIGURATIONS_UPDATE';
export var EMAIL_CONFIGURATION_DESTROY = 'EMAIL_CONFIGURATION_DESTROY';
export var EMAIL_TEMPLATES_UPDATE = 'EMAIL_TEMPLATES_UPDATE';
export var EMAIL_TEMPLATE_DESTROY = 'EMAIL_TEMPLATE_DESTROY';
/**
 * Action Types for Merchant WPF Themes
 */

export var MERCHANT_WPF_THEMES_INITIAL_UPDATE = 'MERCHANT_WPF_THEMES_INITIAL_UPDATE';
export var MERCHANT_WPF_THEMES_UPDATE_FAIL = 'MERCHANT_WPF_THEMES_UPDATE_FAIL';
export var MERCHANT_WPF_THEMES_UPDATE_REQUEST = 'MERCHANT_WPF_THEMES_UPDATE_REQUEST';
export var MERCHANT_WPF_THEMES_UPDATE_SUCCESS = 'MERCHANT_WPF_THEMES_UPDATE_SUCCESS';
/**
 * Action Types for Async Select Multi Field
 */

export var ASYNC_SELECT_MULTI = function ASYNC_SELECT_MULTI(id) {
  return {
    disabledStateUpdate: "".concat(id, "/IS_DISABLED_UPDATE"),
    optionsUpdate: "".concat(id, "/OPTIONS_UPDATE"),
    requestFail: "".concat(id, "/REQUEST_FAIL"),
    requestInProgress: "".concat(id, "/REQUEST_IN_PROGRESS"),
    responseReceive: "".concat(id, "/RESPONSE_RECEIVE")
  };
};
/**
 * Action Types for User Preferences
 */

export var USER_PREFERENCES_REQUEST = 'USER_PREFERENCES_REQUEST';
export var USER_PREFERENCES_REQUEST_FAIL = 'USER_PREFERENCES_REQUEST_FAIL';
export var USER_PREFERENCES_RESPONSE_RECEIVE = 'USER_PREFERENCES_RESPONSE_RECEIVE';
export var CUSTOMIZABLE_COLUMNS = function CUSTOMIZABLE_COLUMNS(preference) {
  return {
    updateSelectedPreferences: "".concat(preference, "/SELECTED_PREFERENCES_UPDATE"),
    requestInProgress: "".concat(preference, "/REQUEST_IN_PROGRESS"),
    requestFail: "".concat(preference, "/REQUEST_FAIL"),
    resetPreference: "".concat(preference, "/RESET"),
    responseReceive: "".concat(preference, "/RESPONSE_RECEIVE")
  };
};
/**
 * Action Types for WPF Supported Features
 */

export var SHOW_WPF_FIELDS_REQUEST = 'SHOW_WPF_FIELDS_REQUEST';
export var SHOW_WPF_FIELDS_REQUEST_FAIL = 'SHOW_WPF_FIELDS_REQUEST_FAIL';
export var SHOW_WPF_FIELDS_RESPONSE_RECEIVE = 'SHOW_WPF_FIELDS_RESPONSE_RECEIVE';
/**
 * Action Types for WPF Top Level bank Codes
 */

export var WPF_TOP_LEVEL_REQUEST = 'WPF_TOP_LEVEL_REQUEST';
export var WPF_TOP_LEVEL_REQUEST_FAIL = 'WPF_TOP_LEVEL_REQUEST_FAIL';
export var WPF_TOP_LEVEL_RESPONSE_RECEIVE = 'WPF_TOP_LEVEL_RESPONSE_RECEIVE';
/**
 * Action Types for WPF Allowed Domains
 */

export var WPF_ALLOWED_DOMAINS_REQUEST = 'WPF_ALLOWED_DOMAINS_REQUEST';
export var WPF_ALLOWED_DOMAINS_REQUEST_FAIL = 'WPF_ALLOWED_DOMAINS_REQUEST_FAIL';
export var WPF_ALLOWED_DOMAINS_RESPONSE_RECEIVE = 'WPF_ALLOWED_DOMAINS_RESPONSE_RECEIVE';
/**
 * Action Types for PayPal Merchant registration
 */

export var PAY_PAL_MERCHANT_REGISTRATION_FAIL = 'PAY_PAL_MERCHANT_REGISTRATION_FAIL';
export var PAY_PAL_MERCHANT_REGISTRATION_REQUEST = 'PAY_PAL_MERCHANT_REGISTRATION_REQUEST';
export var PAY_PAL_MERCHANT_REGISTRATION_RECEIVE = 'PAY_PAL_MERCHANT_REGISTRATION_RECEIVE';
/**
 * Action Types for Panel Log
 */

export var PANEL_LOG = function PANEL_LOG(logType) {
  return {
    requestFail: "".concat(logType, "/REQUEST_FAIL"),
    requestInProgress: "".concat(logType, "/REQUEST_IN_PROGRESS"),
    responseReceive: "".concat(logType, "/RESPONSE_RECEIVE")
  };
};
/**
 * Action Types for Upload File
 */

export var FILE_UPLOAD = function FILE_UPLOAD(inputName) {
  return {
    showProgress: "".concat(inputName, "/SHOW_PROGRESS"),
    percentLoaded: "".concat(inputName, "/PERCENT_LOADED"),
    setResponse: "".concat(inputName, "/SET_RESPONSE"),
    uploadReset: "".concat(inputName, "/UPLOAD_RESET")
  };
};
/**
 * Action Types for User Enable
 */

export var USER_STATUS = function USER_STATUS(userID) {
  return {
    fail: "".concat(userID, "/USER_STATUS_FAIL"),
    receive: "".concat(userID, "/USER_STATUS_RECEIVE"),
    request: "".concat(userID, "/USER_STATUS_REQUEST"),
    update: "".concat(userID, "/USER_STATUS_UPDATE")
  };
};
/**
 * Action Types for Flash Message
 */

export var FLASH_MESSAGE_SET = 'FLASH_MESSAGE_SET';
export var FLASH_MESSAGE_CLEAR = 'FLASH_MESSAGE_CLEAR';
/**
 * Action Types for Merchant Credentials
 */

export var MERCHANT_CREDENTIALS_REQUEST = 'MERCHANT_CREDENTIALS_REQUEST';
export var MERCHANT_CREDENTIALS_REQUEST_FAIL = 'MERCHANT_CREDENTIALS_REQUEST_FAIL';
export var MERCHANT_CREDENTIALS_REQUEST_SUCCESS = 'MERCHANT_CREDENTIALS_REQUEST_SUCCESS';
export var MERCHANT_CREDENTIALS_UPDATE_FAIL = 'MERCHANT_CREDENTIALS_UPDATE_FAIL';
export var MERCHANT_CREDENTIALS_UPDATE_REQUEST = 'MERCHANT_CREDENTIALS_UPDATE_REQUEST';
export var MERCHANT_CREDENTIALS_UPDATE_SUCCESS = 'MERCHANT_CREDENTIALS_UPDATE_SUCCESS';
export var MERCHANT_CREDENTIALS_CREATE_FAIL = 'MERCHANT_CREDENTIALS_CREATE_FAIL';
export var MERCHANT_CREDENTIALS_CREATE_REQUEST = 'MERCHANT_CREDENTIALS_CREATE_REQUEST';
export var MERCHANT_CREDENTIALS_CREATE_SUCCESS = 'MERCHANT_CREDENTIALS_CREATE_SUCCESS';
export var MERCHANT_CREDENTIALS_DECRYPT_FAIL = 'MERCHANT_CREDENTIALS_DECRYPT_FAIL';
export var MERCHANT_CREDENTIALS_DECRYPT_REQUEST = 'MERCHANT_CREDENTIALS_DECRYPT_REQUEST';
export var MERCHANT_CREDENTIALS_DECRYPT_SUCCESS = 'MERCHANT_CREDENTIALS_DECRYPT_SUCCESS';
/**
 * Action Types for PayByLink form
 */

export var PBL_FORM_SET_ADDRESS = 'PBL_FORM_SET_ADDRESS';
/**
 * Action Types for VirtualTerminal form
 */

export var VT_FORM_STATE_RECEIVED = 'VT_FORM_STATE_RECEIVED';
export var VT_FORM_STATE_REQUEST = 'VT_FORM_STATE_REQUEST';
export var VT_FORM_STATE_REQUEST_FAILED = 'VT_FORM_STATE_REQUEST_FAILED';
export var VT_FORM_DATA_UPDATE = 'VT_FORM_DATA_UPDATE';
/**
 * Action Types for WpfCustomTheme V2
 */

export var WPF_CUSTOM_THEME_V2_REQUEST = 'WPF_CUSTOM_THEME_V2_REQUEST';
export var WPF_CUSTOM_THEME_V2_REQUEST_FAIL = 'WPF_CUSTOM_THEME_V2_REQUEST_FAIL';
export var WPF_CUSTOM_THEME_V2_RESPONSE_RECEIVE = 'WPF_CUSTOM_THEME_V2_RESPONSE_RECEIVE';
/**
 * Action type for contracts form
 */

export var CONTRACT_FORM_SET_FEATURE = 'CONTRACT_FORM_SET_FEATURE';
export var CONTRACT_FORM_SET_MCC = 'CONTRACT_FORM_SET_MCC';
/**
 * Action Types for WpfCustomTheme V2 Background Image Upload
 */

export var WPF_CUSTOM_THEME_V2_IMAGE_UPLOAD = 'WPF_CUSTOM_THEME_V2_IMAGE_UPLOAD';
export var WPF_CUSTOM_THEME_V2_IMAGE_UPLOAD_FAIL = 'WPF_CUSTOM_THEME_V2_IMAGE_UPLOAD_FAIL';
export var WPF_CUSTOM_THEME_V2_IMAGE_UPLOAD_RECEIVE = 'WPF_CUSTOM_THEME_V2_IMAGE_UPLOAD_RECEIVE';
/**
 * Action Types for MerchantRemindersConfig
 */

export var MERCHANT_REMINDERS_CONFIG_REQUEST = 'MERCHANT_REMINDERS_CONFIG_REQUEST';
export var MERCHANT_REMINDERS_CONFIG_REQUEST_FAIL = 'MERCHANT_REMINDERS_CONFIG_REQUEST_FAIL'; // eslint-disable-next-line max-len, id-length

export var MERCHANT_REMINDERS_CONFIG_RESPONSE_RECEIVE = 'MERCHANT_REMINDERS_CONFIG_RESPONSE_RECEIVE';